import { Alert, useMediaQuery, useTheme } from "@mui/material";
import { SessionManager } from "../../../../services/SessionManager/SessionManager";
import {
  CustomMessageOrderMetaDetails,
  OrderProposalActionType,
} from "../GGCustomMessageTypes";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';

interface OrderProposalActionTakenCardProps {
  orderActionType: OrderProposalActionType;
  orderMetaData: CustomMessageOrderMetaDetails;
}

const OrderProposalActionTakenCard = ({
  orderActionType,
  orderMetaData,
}: OrderProposalActionTakenCardProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  
  const isCurrentUserBuyer =
    orderMetaData?.buyerId === SessionManager.shared.buyer?.id;

  const getResponsiveAlertStyles = () => ({
    border: "1px solid green",
    borderRadius: isMobile ? "8px" : "12px",
    fontSize: isMobile ? "0.9rem" : "1rem",
    padding: isMobile ? "12px" : "16px",
    maxWidth: "100%",
    width: "100%"
  });

  const getErrorAlertStyles = () => ({
    border: "1px solid red",
    borderRadius: isMobile ? "8px" : "12px",
    fontSize: isMobile ? "0.9rem" : "1rem",
    padding: isMobile ? "12px" : "16px",
    maxWidth: "100%",
    width: "100%"
  });

  const renderContent = () => {
    switch (orderActionType) {
      case OrderProposalActionType.accepted:
        return (
        <Alert icon={<CheckCircleIcon fontSize="inherit" />} severity="success" sx={getResponsiveAlertStyles()}>
            {isCurrentUserBuyer
              ? "You have accepted the freelancer's order proposal."
              : "The client has accepted your order proposal."}
          </Alert>
        );

      case OrderProposalActionType.revoked_by_seller:
        return (
          <Alert icon={<ErrorIcon fontSize="inherit" />} severity="error" sx={getErrorAlertStyles()}>
            {isCurrentUserBuyer
              ? "The freelancer has revoked the order proposal."
              : "You have revoked the order proposal."}
          </Alert>
        );

      case OrderProposalActionType.rejected_by_buyer:
        return (
          <Alert icon={<ErrorIcon fontSize="inherit" />} severity="error" sx={getErrorAlertStyles()}>
            {isCurrentUserBuyer
              ? "You have rejected the freelancer's order proposal."
              : "The client has rejected your order proposal."}
          </Alert>
        );

      default:
        return null;
    }
  };

  return <>{renderContent()}</>;
};

export default OrderProposalActionTakenCard;
